import { render, staticRenderFns } from "./RetakeModal.vue?vue&type=template&id=640fa222&scoped=true"
import script from "./RetakeModal.vue?vue&type=script&lang=js"
export * from "./RetakeModal.vue?vue&type=script&lang=js"
import style0 from "./RetakeModal.vue?vue&type=style&index=0&id=640fa222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640fa222",
  null
  
)

export default component.exports